import "../styles/transition.css";
import logo from "./EJ_logo.png";

function Transition() {
	//scrolls signup page into view when arrow is clicked
	const scroll = () => {
		document.querySelector(".signup-scroll-box").scrollIntoView({ behavior: "smooth" });
	};

	return (
		<div className="transition-main">
			<div className="logo-title-container">
				<div className="text1">Until The</div>
				<img src={logo} alt="logo" onClick={scroll} />
				<div className="text2">Hackathon</div>
			</div>

			{/* down arrow  */}
			<button className="scroll-arrow" onClick={scroll}>
				&#8681;
			</button>
		</div>
	);
}

export default Transition;
